/* istanbul ignore file */
// TODO: Create test file

import { computed, inject } from 'vue';
import { CONTEXTUAL_WIDGET_COPIES } from '../../constants/SalesFloor';

const getAvailability = (liveStatus) => (liveStatus ? 'available' : 'unavailable');

const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export default function useCopyData({
  type = '', copy = {},
}) {
  const entryPoint = inject('entryPoint');
  const liveStatus = inject('liveStatus');
  const widgetName = inject('widgetName');
  const isRegistry = inject('isRegistry');
  const virtualAdvisorWidgetName = inject('virtualAdvisorWidgetName');

  const pageCopyPreFix = computed(() => {
    if (type === 'brand') {
      return type;
    } if (type === 'specialty') {
      return `${getAvailability(liveStatus?.value)}Specialty`;
    }
    return '';
  });

  const pageCopyPostFix = computed(() => {
    if (type === 'brand') {
      return type;
    } if (type === 'specialty' && !!isRegistry?.value) {
      return `${entryPoint?.value}Registry`;
    } if (type === 'specialty' && !isRegistry?.value) {
      return 'common';
    }
    return '';
  });

  const contextualWidgetCopies = computed(() => CONTEXTUAL_WIDGET_COPIES[widgetName?.value || ''] || {});

  const defaultCopy = computed(() => contextualWidgetCopies.value?.default || '');
  const formattedCopyPreFix = computed(() => contextualWidgetCopies.value?.copiesPreFix?.[pageCopyPreFix.value] || '');
  const formattedCopyPostFix = computed(() => contextualWidgetCopies.value?.copiesPostFix?.[pageCopyPostFix.value] || '');

  const useDefaultCopy = computed(
    () => (!copy.value
        || !(formattedCopyPreFix.value && formattedCopyPostFix.value)
    )
          && widgetName?.value !== 'floatingContextual',
  );

  return {
    fullCopy: computed(() => {
      // TODO -> revert and remove from this later once better system is found
      if (widgetName.value === 'virtualAdvisorWidget' && virtualAdvisorWidgetName.value === 'mini') {
        return `Talk to a ${capitalizeFirstLetter(copy.value || 'style')} ${capitalizeFirstLetter(formattedCopyPostFix.value || 'expert')}`;
      }
      return (useDefaultCopy.value ? defaultCopy.value : `${formattedCopyPreFix.value} ${copy.value} ${formattedCopyPostFix.value}`);
    }),
  };
}
